import React, { useState } from 'react';

import Layout from 'ds/Layout';

import Icon from './Icon';

export interface Props {
  checked: boolean;
  size?: 'sm' | 'lg';
}

const SIZE_MAP = {
  sm: { dimension: 24, iconSize: 12 },
  lg: { dimension: 32, iconSize: 20 }
} as const;

const CheckCircleDisplay: React.FC<Props> = ({ checked, size = 'lg' }) => {
  const [isActive, setIsActive] = useState<boolean>();
  const [hover, setHover] = useState<boolean>();
  const { dimension, iconSize } = SIZE_MAP[size];
  return (
    <Layout width={dimension} height={dimension} align="center" justify="center">
      {!checked && (
        <Layout
          borderRadius={'circular'}
          align="center"
          justify="center"
          position="absolute"
          color={hover ? 'blue-500' : 'gray-200'}
          width={dimension}
          height={dimension}
        />
      )}
      <Layout
        zIndex={1}
        justify="center"
        position="absolute"
        align="center"
        borderRadius="circular"
        {...(checked ? { width: dimension, height: dimension } : { width: dimension - 4, height: dimension - 4 })}
        color={isActive ? 'blue-600' : checked ? 'blue-500' : 'white'}
        hoverColor={checked ? undefined : 'black'}
        transition="all 50ms"
        onMouseDown={() => {
          setIsActive(true);
        }}
        onMouseUp={() => {
          setIsActive(false);
        }}
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
          setIsActive(false);
        }}
      ></Layout>
      <Layout
        align="center"
        justify="center"
        zIndex={1}
        {...(checked ? { width: dimension, height: dimension } : { width: dimension - 4, height: dimension - 4 })}
        onMouseDown={() => {
          setIsActive(true);
        }}
        onMouseUp={() => {
          setIsActive(false);
        }}
        onMouseEnter={() => {
          setHover(true);
        }}
        onMouseLeave={() => {
          setHover(false);
          setIsActive(false);
        }}
      >
        <Icon name="checkmark" size={iconSize} color="white" stroke={2} />
      </Layout>
    </Layout>
  );
};

export default CheckCircleDisplay;
